import { Heading, Button } from '@flixbus/honeycomb-react';
import VoucherList from './VoucherList';
import { BatchUpdateProvider } from '../../context/VoucherBatchUpdateProvider';
import { VoucherListProvider } from '../../context/VoucherListProvider';

import styles from './dashboard.module.scss';
import { Icon, IconArrowRight } from '@flixbus/honeycomb-icons-react';

const Dashboard = () => {
  const serviceDeskUrl = 'https://flixtech.atlassian.net/servicedesk/customer/portal/74/group/195';

  return (
    <>
      <div className={styles.headerContainer}>
        <Heading size={1} sectionHeader flushSpace>
          Voucher Portal
        </Heading>
        <Button size='md' Elem='a' href={serviceDeskUrl} target='_blank'>
          Get help or report a problem <Icon InlineIcon={IconArrowRight} />
        </Button>
      </div>
      <VoucherListProvider>
        <BatchUpdateProvider>
          <VoucherList />
        </BatchUpdateProvider>
      </VoucherListProvider>
    </>
  );
};

export default Dashboard;
